import api from '@Services/api';
import { FamilyKey } from '../Types/Analytics.types';

export type HubTableRequest = {
	page?: number;
	perPage?: number;
	query?: string;
	sortBy?: { field: string; direction?: 'asc' | 'desc' };
	from?: Date;
	to?: Date;
	export?: boolean;
	instructor_id?: number;
};

export type HubGraphRequest = {
	slice: string;
	from: Date;
	to: Date;
	entity_ids?: number[];
	instructor_id?: number;
};

export const OverviewRequest = (payload: { from?: Date; to?: Date; instructor_id?: number }) =>
	api.post('statistics/overview', payload);

export const OverviewGraphRequest = (payload: HubGraphRequest) =>
	api.post('statistics/overview/graph', payload);

export const FamilyAnalyticRequest = (family: FamilyKey, payload: HubTableRequest) =>
	api.post(`statistics/${family}/analytic`, payload, {
		responseType: payload.export ? 'text' : 'json',
	});

export const FamilyRevenueRequest = (family: FamilyKey, payload: HubTableRequest) =>
	api.post(`statistics/${family}/revenue`, payload, {
		responseType: payload.export ? 'text' : 'json',
	});

export const FamilyGraphRequest = (family: FamilyKey, payload: HubGraphRequest) =>
	api.post(`statistics/${family}/graph`, payload);

export const InstructorsStatisticsRequest = (payload: HubTableRequest) =>
	api.post('statistics/instructors', payload, {
		responseType: payload.export ? 'text' : 'json',
	});

export const EducationStatisticsRequest = (payload: {
	dimension: 'year' | 'section' | 'subject';
	from?: Date;
	to?: Date;
	instructor_id?: number;
}) => api.post('statistics/education', payload);

export const UsageStatisticsRequest = (payload: { from?: Date; to?: Date; instructor_id?: number }) =>
	api.post('statistics/usage', payload);

export const UsageInstructorsRequest = (payload: HubTableRequest) =>
	api.post('statistics/usage/instructors', payload, {
		responseType: payload.export ? 'text' : 'json',
	});

/**
 * CSV download with the UTF-8 BOM re-added so Excel renders Arabic names —
 * the exportSlice.exportPayload recipe, usable from direct-call pages.
 */
export const downloadCsvResponse = (response: any, fallbackName: string) => {
	const blob = new Blob(['\uFEFF' + response.data], { type: 'text/csv;charset=utf-8' });
	const url = URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.download =
		response.headers?.['content-disposition']?.split('=')[1] ?? `${fallbackName}.csv`;
	link.click();
	URL.revokeObjectURL(url);
};
